import { BP42InitialState } from '@r1-frontend/bp42/reducer/initialState';

const getStartedTyping = (state: BP42InitialState): boolean => state._startedTyping;

export default getStartedTyping;
